/*
 *
 * UrlClickToPayField
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 03-Jun-2026
 */

import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  baseUrl: {
    id: 't.app.terminalsManagement.vasConfiguration.scof.baseUrl',
    defaultMessage: 'Base URL'
  },
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  },
})
